import type { PromoMessage } from './usePlansCatalog';

/**
 * Mensagem da oferta especial de reativação (campanha "Reencontro") no JusBill.
 *
 * No JusBill o plano da oferta é o próprio "cupom": a resposta de /offers não traz
 * `coupon.subtitle`/`description`, então o texto fica aqui, preso ao `gateway_id`
 * cobrado. Só aparece para esse plano (e com `is_promo`); outra oferta especial sem
 * texto do backend mostra apenas o selo.
 *
 * ATENÇÃO: a frase promete condições da campanha (7 dias grátis, 50% no 2º mês).
 * Se a campanha mudar e o plano continuar com este gateway_id, atualize o texto.
 * Texto definido em 2026-10-23. O texto escrito no backend, quando existir, tem
 * prioridade sobre este.
 */
export const REACTIVATION_PROMO_MESSAGE_BY_GATEWAY_ID: Record<string, PromoMessage> = {
  '8789259': {
    title: 'Oferta especial Reencontro',
    description:
      'Reative sua assinatura por 7 dias grátis e ganhe 50% de desconto no segundo mês no plano Ultimate.',
  },
};

export const getReactivationPromoMessage = (
  gatewayId: number | string | null | undefined,
): PromoMessage | null =>
  gatewayId == null
    ? null
    : REACTIVATION_PROMO_MESSAGE_BY_GATEWAY_ID[String(gatewayId)] ?? null;
